module.exports = __webpack_public_path__ + "img/profit-and-cash-flow.6ba18417.png";